// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__Xz0Kb","shadow":"styles_shadow__4Uj5D"};